import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import DowloadCenterTable from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";

const table_name = "i1_download_center";

export default function I1DownloadCenter() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_download_center", {
        ns: "titles",
        defaultValue: "Quantilia | Download Center",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route index element={<DowloadCenterTable table_name={table_name} />} />
    </Routes>
  );
}
